module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kansai-2-c45a61079adbc7ee2fc01788ed4b33ca.jpg";